// ! This file was auto-generated from the rolodex OpenAPI schema. Do not override this file.
export const Tags = {
    Healthchecks: "Healthchecks",
    client_mapping: "client-mapping",
    oauth: "oauth",
    oauth_clients: "oauth-clients",
    oauth_discovery: "oauth-discovery",
    oidc: "oidc",
    proxy: "proxy",
    public: "public",
    pusher: "pusher",
    saml: "saml",
    token: "token",
    user: "user"
} as const;
export type TagName = (typeof Tags)[keyof typeof Tags];
